import React from 'react';
import Assign_Teacher from './Assign_Teacher';
import '../../../CommonCSS/SocietyCSS.css'

const Assign_TeacherApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Assign Teacher</h5>
          </div>  
        </div>
        <Assign_Teacher/>
      </div>
    </div >
  );
};

export default Assign_TeacherApp;
